/**
 * NavigationUserEvents
 * Registry of navigation-centric events in the dashboard
 */
export enum NavigationUserEvents {
    pageLoaded = "Navigation - Page Loaded",
    anchorClick = "Navigation - Anchor Link Click",
    internalLinkClick = "Navigation - Internal Link Click",
    expandSidebar = "Navigation - Expand Sidebar",
    collapseSidebar = "Navigation - Collapse Sidebar",
    dismissBanner = "Navigation - Dismiss Banner",
    weAreHiring = "Navigation - We're Hiring Click",
    navbarLoginClick = "Navbar - Login Click",
    navbarRegisterClick = "Navbar - Register Click",
    navbarIconClick = "Navbar - Icon Link",
    navbarRequestDemoClick = "Navbar - Request Demo Click",
    navbarDataAPICtaClick = "Navbar - Data API CTA Click",
    navbarMediaCitationsClick = "Navbar - Media & Citations Click",
    navbarIssuerMenuOpen = "Navbar - Issuer Menu Open",
    navbarIssuerRegistrationClick = "Navbar - For Issuers - Issuer Registration CTA Click",
    sidebarRegisterAssetCtaClick = "Sidebar - For Issuers - Register Asset CTA Click",
    mobileNavDirectorySignUpClick = "Mobile Nav - Directory Sign Up Click",
}
